export default{list:"w_Bj",divider:"w_Bk"};
